var _desc, _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAdministration(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: 512,
    height: 512,
    role: "img",
    "aria-labelledby": titleId,
    ref: svgRef
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "t"
  }, "Administration") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "t"
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", {
    id: "d"
  }, "Hierarchie des droits : une racine et ses branches.")), _style || (_style = /*#__PURE__*/React.createElement("style", null, "\n  :root{\n    --line:#025D7D;\n    --accent:#30C5E5;\n  }\n  @media (prefers-color-scheme: dark){\n    :root{ --line:#7FD8EE; --accent:#30C5E5; }\n  }\n  .e   {fill:none;stroke:var(--line);stroke-width:2.6;stroke-linecap:round;stroke-linejoin:round}\n  .e2  {fill:none;stroke:var(--line);stroke-width:1.9;stroke-linecap:round;stroke-linejoin:round;opacity:.7}\n  .e3  {fill:none;stroke:var(--line);stroke-width:1.2;stroke-linecap:round;opacity:.34}\n  .h   {fill:none;stroke:var(--line);stroke-width:1.2;stroke-linecap:round;opacity:.22;stroke-dasharray:4 6}\n  .a   {fill:none;stroke:var(--accent);stroke-width:2.8;stroke-linecap:round;stroke-linejoin:round}\n  .a2  {fill:none;stroke:var(--accent);stroke-width:1.9;stroke-linecap:round;stroke-linejoin:round;opacity:.75}\n  .face {fill:var(--accent);opacity:.07;stroke:none}\n  .face2{fill:var(--accent);opacity:.16;stroke:none}\n  .faceL{fill:var(--line);opacity:.07;stroke:none}\n  .dot  {fill:var(--accent)}\n  .dotl {fill:var(--line);opacity:.45}\n  .txt  {fill:var(--line);font-family:Montserrat,'Helvetica Neue',Arial,sans-serif;font-weight:700}\n  .txta {fill:var(--accent);font-family:Montserrat,'Helvetica Neue',Arial,sans-serif;font-weight:700}\n  .halo {fill:var(--accent);opacity:.16;transform-box:fill-box;transform-origin:center;\n         animation:pulse 3.4s ease-in-out infinite}\n  .flow {stroke-dasharray:6 10;animation:flow 2.6s linear infinite}\n  .flow2{stroke-dasharray:4 8;animation:flow 3.4s linear infinite reverse}\n  .drift{transform-box:fill-box;transform-origin:center;\n         animation:drift 6s ease-in-out infinite}\n  #scene{animation:float 8s ease-in-out infinite}\n  @keyframes pulse{0%,100%{transform:scale(.62);opacity:.09}50%{transform:scale(1.32);opacity:.34}}\n  @keyframes flow {to{stroke-dashoffset:-32}}\n  @keyframes float{0%,100%{transform:translateY(0)}50%{transform:translateY(-7px)}}\n  @keyframes drift{0%,100%{transform:translate(0,0)}50%{transform:translate(0,-9px)}}\n  @media (prefers-reduced-motion: reduce){*{animation:none !important}}\n  .d0{animation-delay:0.0s}\n  .d1{animation-delay:0.1s}\n  .d2{animation-delay:0.2s}\n  .d3{animation-delay:0.3s}\n  .d4{animation-delay:0.4s}\n  .d5{animation-delay:0.5s}\n  .d6{animation-delay:0.6s}\n  .d7{animation-delay:0.7s}\n  .d8{animation-delay:0.8s}\n  .d9{animation-delay:0.9s}\n  .d10{animation-delay:1.0s}\n  .d11{animation-delay:1.1s}\n  .d12{animation-delay:1.2s}\n  .d13{animation-delay:1.3s}\n  .d14{animation-delay:1.4s}\n  .d15{animation-delay:1.5s}\n  .d16{animation-delay:1.6s}\n  .d17{animation-delay:1.7s}\n  .d18{animation-delay:1.8s}\n  .d19{animation-delay:1.9s}\n  .d20{animation-delay:2.0s}\n  .d21{animation-delay:2.1s}\n  .d22{animation-delay:2.2s}\n  .d23{animation-delay:2.3s}\n  .d24{animation-delay:2.4s}\n  .d25{animation-delay:2.5s}\n  .d26{animation-delay:2.6s}\n  .d27{animation-delay:2.7s}\n  .d28{animation-delay:2.8s}\n  .d29{animation-delay:2.9s}\n  .d30{animation-delay:3.0s}\n  .d31{animation-delay:3.1s}\n  .d32{animation-delay:3.2s}\n  .d33{animation-delay:3.3s}\n  .d34{animation-delay:3.4s}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "scene"
  }, /*#__PURE__*/React.createElement("path", {
    className: "e3",
    d: "M 250.3 173.1 L 444.6 285.3 L 261.7 390.9 L 67.4 278.7 Z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "e3",
    x1: 250.3,
    y1: 192.9,
    x2: 101.7,
    y2: 278.7
  }), /*#__PURE__*/React.createElement("line", {
    className: "e3",
    x1: 290.3,
    y1: 216,
    x2: 141.7,
    y2: 301.8
  }), /*#__PURE__*/React.createElement("line", {
    className: "e3",
    x1: 330.3,
    y1: 239.1,
    x2: 181.7,
    y2: 324.9
  }), /*#__PURE__*/React.createElement("line", {
    className: "e3",
    x1: 370.3,
    y1: 262.2,
    x2: 221.7,
    y2: 348
  }), /*#__PURE__*/React.createElement("line", {
    className: "e3",
    x1: 410.3,
    y1: 285.3,
    x2: 261.7,
    y2: 371.1
  }), /*#__PURE__*/React.createElement("line", {
    className: "e3",
    x1: 250.3,
    y1: 192.9,
    x2: 410.3,
    y2: 285.3
  }), /*#__PURE__*/React.createElement("line", {
    className: "e3",
    x1: 213.1,
    y1: 214.4,
    x2: 373.2,
    y2: 306.8
  }), /*#__PURE__*/React.createElement("line", {
    className: "e3",
    x1: 176,
    y1: 235.8,
    x2: 336,
    y2: 328.2
  }), /*#__PURE__*/React.createElement("line", {
    className: "e3",
    x1: 138.8,
    y1: 257.2,
    x2: 298.9,
    y2: 349.6
  }), /*#__PURE__*/React.createElement("line", {
    className: "e3",
    x1: 101.7,
    y1: 278.7,
    x2: 261.7,
    y2: 371.1
  }), /*#__PURE__*/React.createElement("line", {
    className: "e3",
    x1: 256,
    y1: 186.3,
    x2: 234.6,
    y2: 201.1
  }), /*#__PURE__*/React.createElement("line", {
    className: "a2 flow",
    x1: 256,
    y1: 186.3,
    x2: 234.6,
    y2: 201.1
  }), /*#__PURE__*/React.createElement("line", {
    className: "e3",
    x1: 256,
    y1: 186.3,
    x2: 336,
    y2: 259.7
  }), /*#__PURE__*/React.createElement("line", {
    className: "a2 flow",
    x1: 256,
    y1: 186.3,
    x2: 336,
    y2: 259.7
  }), /*#__PURE__*/React.createElement("line", {
    className: "e3",
    x1: 256,
    y1: 186.3,
    x2: 197.4,
    y2: 281.2
  }), /*#__PURE__*/React.createElement("line", {
    className: "a2 flow",
    x1: 256,
    y1: 186.3,
    x2: 197.4,
    y2: 281.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "face2",
    d: "M 301.7 143.4 L 256 169.8 L 256 212.7 L 301.7 186.3 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "faceL",
    d: "M 210.3 143.4 L 256 169.8 L 256 212.7 L 210.3 186.3 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "face",
    d: "M 256 117 L 301.7 143.4 L 256 169.8 L 210.3 143.4 Z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "h",
    x1: 256,
    y1: 159.9,
    x2: 256,
    y2: 117
  }), /*#__PURE__*/React.createElement("line", {
    className: "h",
    x1: 256,
    y1: 159.9,
    x2: 301.7,
    y2: 186.3
  }), /*#__PURE__*/React.createElement("line", {
    className: "h",
    x1: 256,
    y1: 159.9,
    x2: 210.3,
    y2: 186.3
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M 256 117 L 301.7 143.4 L 256 169.8 L 210.3 143.4 Z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "e",
    x1: 301.7,
    y1: 143.4,
    x2: 301.7,
    y2: 186.3
  }), /*#__PURE__*/React.createElement("line", {
    className: "e",
    x1: 256,
    y1: 169.8,
    x2: 256,
    y2: 212.7
  }), /*#__PURE__*/React.createElement("line", {
    className: "e",
    x1: 210.3,
    y1: 143.4,
    x2: 210.3,
    y2: 186.3
  }), /*#__PURE__*/React.createElement("line", {
    className: "e",
    x1: 301.7,
    y1: 186.3,
    x2: 256,
    y2: 212.7
  }), /*#__PURE__*/React.createElement("line", {
    className: "e",
    x1: 256,
    y1: 212.7,
    x2: 210.3,
    y2: 186.3
  }), /*#__PURE__*/React.createElement("path", {
    className: "face2",
    d: "M 268.9 201.1 L 234.6 220.9 L 234.6 255.6 L 268.9 235.8 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "faceL",
    d: "M 200.3 201.1 L 234.6 220.9 L 234.6 255.6 L 200.3 235.8 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "face",
    d: "M 234.6 181.3 L 268.9 201.1 L 234.6 220.9 L 200.3 201.1 Z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "h",
    x1: 234.6,
    y1: 216,
    x2: 234.6,
    y2: 181.3
  }), /*#__PURE__*/React.createElement("line", {
    className: "h",
    x1: 234.6,
    y1: 216,
    x2: 268.9,
    y2: 235.8
  }), /*#__PURE__*/React.createElement("line", {
    className: "h",
    x1: 234.6,
    y1: 216,
    x2: 200.3,
    y2: 235.8
  }), /*#__PURE__*/React.createElement("path", {
    className: "e2",
    d: "M 234.6 181.3 L 268.9 201.1 L 234.6 220.9 L 200.3 201.1 Z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "e2",
    x1: 268.9,
    y1: 201.1,
    x2: 268.9,
    y2: 235.8
  }), /*#__PURE__*/React.createElement("line", {
    className: "e2",
    x1: 234.6,
    y1: 220.9,
    x2: 234.6,
    y2: 255.6
  }), /*#__PURE__*/React.createElement("line", {
    className: "e2",
    x1: 200.3,
    y1: 201.1,
    x2: 200.3,
    y2: 235.8
  }), /*#__PURE__*/React.createElement("line", {
    className: "e2",
    x1: 268.9,
    y1: 235.8,
    x2: 234.6,
    y2: 255.6
  }), /*#__PURE__*/React.createElement("line", {
    className: "e2",
    x1: 234.6,
    y1: 255.6,
    x2: 200.3,
    y2: 235.8
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "halo d0",
    cx: 234.6,
    cy: 196.2,
    r: 9
  }), /*#__PURE__*/React.createElement("circle", {
    className: "dot",
    cx: 234.6,
    cy: 196.2,
    r: 3.4
  })), /*#__PURE__*/React.createElement("path", {
    className: "face2",
    d: "M 370.3 259.7 L 336 279.5 L 336 314.2 L 370.3 294.4 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "faceL",
    d: "M 301.7 259.7 L 336 279.5 L 336 314.2 L 301.7 294.4 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "face",
    d: "M 336 239.9 L 370.3 259.7 L 336 279.5 L 301.7 259.7 Z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "h",
    x1: 336,
    y1: 274.6,
    x2: 336,
    y2: 239.9
  }), /*#__PURE__*/React.createElement("line", {
    className: "h",
    x1: 336,
    y1: 274.6,
    x2: 370.3,
    y2: 294.4
  }), /*#__PURE__*/React.createElement("line", {
    className: "h",
    x1: 336,
    y1: 274.6,
    x2: 301.7,
    y2: 294.4
  }), /*#__PURE__*/React.createElement("path", {
    className: "e2",
    d: "M 336 239.9 L 370.3 259.7 L 336 279.5 L 301.7 259.7 Z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "e2",
    x1: 370.3,
    y1: 259.7,
    x2: 370.3,
    y2: 294.4
  }), /*#__PURE__*/React.createElement("line", {
    className: "e2",
    x1: 336,
    y1: 279.5,
    x2: 336,
    y2: 314.2
  }), /*#__PURE__*/React.createElement("line", {
    className: "e2",
    x1: 301.7,
    y1: 259.7,
    x2: 301.7,
    y2: 294.4
  }), /*#__PURE__*/React.createElement("line", {
    className: "e2",
    x1: 370.3,
    y1: 294.4,
    x2: 336,
    y2: 314.2
  }), /*#__PURE__*/React.createElement("line", {
    className: "e2",
    x1: 336,
    y1: 314.2,
    x2: 301.7,
    y2: 294.4
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "halo d3",
    cx: 336,
    cy: 254.8,
    r: 9
  }), /*#__PURE__*/React.createElement("circle", {
    className: "dot",
    cx: 336,
    cy: 254.8,
    r: 3.4
  })), /*#__PURE__*/React.createElement("path", {
    className: "face2",
    d: "M 231.7 281.2 L 197.4 301 L 197.4 335.6 L 231.7 315.8 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "faceL",
    d: "M 163.1 281.2 L 197.4 301 L 197.4 335.6 L 163.1 315.8 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "face",
    d: "M 197.4 261.4 L 231.7 281.2 L 197.4 301 L 163.1 281.2 Z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "h",
    x1: 197.4,
    y1: 296,
    x2: 197.4,
    y2: 261.4
  }), /*#__PURE__*/React.createElement("line", {
    className: "h",
    x1: 197.4,
    y1: 296,
    x2: 231.7,
    y2: 315.8
  }), /*#__PURE__*/React.createElement("line", {
    className: "h",
    x1: 197.4,
    y1: 296,
    x2: 163.1,
    y2: 315.8
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M 197.4 261.4 L 231.7 281.2 L 197.4 301 L 163.1 281.2 Z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "a",
    x1: 231.7,
    y1: 281.2,
    x2: 231.7,
    y2: 315.8
  }), /*#__PURE__*/React.createElement("line", {
    className: "a",
    x1: 197.4,
    y1: 301,
    x2: 197.4,
    y2: 335.6
  }), /*#__PURE__*/React.createElement("line", {
    className: "a",
    x1: 163.1,
    y1: 281.2,
    x2: 163.1,
    y2: 315.8
  }), /*#__PURE__*/React.createElement("line", {
    className: "a",
    x1: 231.7,
    y1: 315.8,
    x2: 197.4,
    y2: 335.6
  }), /*#__PURE__*/React.createElement("line", {
    className: "a",
    x1: 197.4,
    y1: 335.6,
    x2: 163.1,
    y2: 315.8
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "halo d6",
    cx: 197.4,
    cy: 276.2,
    r: 9
  }), /*#__PURE__*/React.createElement("circle", {
    className: "dot",
    cx: 197.4,
    cy: 276.2,
    r: 3.4
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "halo d1",
    cx: 256,
    cy: 140.1,
    r: 9
  }), /*#__PURE__*/React.createElement("circle", {
    className: "dot",
    cx: 256,
    cy: 140.1,
    r: 4.2
  })), /*#__PURE__*/React.createElement("circle", {
    className: "dot drift d0",
    cx: 118,
    cy: 128,
    r: 3.4
  }), /*#__PURE__*/React.createElement("circle", {
    className: "dotl drift d11",
    cx: 398,
    cy: 150,
    r: 4.6
  }), /*#__PURE__*/React.createElement("circle", {
    className: "dot drift d20",
    cx: 424,
    cy: 322,
    r: 3
  }), /*#__PURE__*/React.createElement("circle", {
    className: "dotl drift d6",
    cx: 92,
    cy: 306,
    r: 2.6
  }), /*#__PURE__*/React.createElement("circle", {
    className: "dot drift d26",
    cx: 352,
    cy: 96,
    r: 2.8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "dotl drift d13",
    cx: 128,
    cy: 402,
    r: 2.8
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdministration);
export default __webpack_public_path__ + "static/media/administration.d05a52ea7f77cba2efe5a2e55c6a4e0f.svg";
export { ForwardRef as ReactComponent };